<form [formGroup]="form" class="input-grid-gaps grid-2col">
    <app-date-input
        id="insuredFrom"
        label="inputs.insurance.insuredFrom"
        [form]="form"
    ></app-date-input>

    <app-date-input
        id="insuredTo"
        label="inputs.insurance.insuredTo"
        [form]="form"
        timeType="endOfDay"
        [showClear]="true"
    ></app-date-input>

    <app-insurance-company-select-input
        id="insuranceAbbr"
        [autoDisplayFirst]="true"
        [form]="form"
    ></app-insurance-company-select-input>

    <app-select-input
        id="insuranceType"
        [staticOptions]="insuranceTypeEnumOptions"
        [autoDisplayFirst]="true"
        valueKey="value"
        [form]="form"
    ></app-select-input>

    @if (overlap) {
        <app-error-float-message
            class="fr-2"
            message="errors.DATE_OVERLAPS"
        ></app-error-float-message>
    }

    @if (workBilled) {
        <app-error-float-message
            class="fr-2"
            message="errors.WORK_BILLED"
        ></app-error-float-message>
    }

    @if (toBeforeFrom) {
        <app-error-float-message
            class="fr-2"
            message="errors.DATE_FROM_PRECEDES_DATE_TO"
        ></app-error-float-message>
    }

</form>
